export default {
  banners:[
    // imgUrl: '图片地址'， title: '标题文本', description: '描述信息', component: '跳转组件名称'
      {
        imgUrl: require('../../../assets/images/services/banner-10.jpg'),
        title: 'カスタマーサービス',
        description: '',
        component: ''
      }
  ],
  items:[
    {
      title: '優れたカスタマーサービスを提供し、顧客体験が私たちの価値を決定します',
      description: `<p style="font-size:1.05rem">厳しい市場競争の中で、カスタマーサービスは企業が直面する重要な課題の一つとなっています。顧客満足を追求し、顧客のニーズを満たすことを中心に据えることが重要です。現代のマーケティングは顧客視点を重視し、企業は顧客満足度を通じて利益を得ます。そのため、購買前・購買中・購買後のいずれにおいても、専門のカスタマーサポートチームが顧客満足度を守る必要があります。</p>`
    },
    {
      title: 'MaesInfoは専門のカスタマーサポートチームを有しており、以下を備えています',
      description: `<span class='img' style="background:url(`+require('../../../assets/images/services/pic-10.jpg')+`)"></span>
      <span class="list">
      <i></i>様々な突発的な状況に対応できる強いメンタルと品性<br/>
      <i></i>優れたコミュニケーション能力と業界知識などの専門スキル<br/>
      <i></i>顧客第一のサービス理念を持ち、顧客満足度100%を目指します
      </span>`
    }
  ]
}
